import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput as parseFraction, formatLatexPreview } from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 14 }, (_, i) => i + 3);
  const a = pick(A), b = pick(A), h = pick(A);
  const P = 0.5 * (a + b) * h;
  return { type: "TrapezoidAreaFromBasesAndHeightTask", data: { a, b, h, P } };
}

export function renderTask({ data }) {
  const { a, b, h } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest trapez o podstawach <InlineMath math={`a=${a}`} />, <InlineMath math={`b=${b}`} /> i wysokości <InlineMath math={`h=${h}`} />.
      Oblicz jego pole <InlineMath math={"P"} />.
    </div>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return <FractionInput value={raw} onChange={(v) => onChange({ raw: normalize(v) })} disabled={disabled} label="P" placeholder="np. 72" />;
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.P) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`P=${data.P}`} />;

export function renderExplanation({ data }) {
  const { a, b, h, P } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na pole trapezu: <InlineMath math={"P=\\tfrac{1}{2}(a+b)h"} />.
      <BlockMath math={`P=\\tfrac{1}{2}(${a}+${b})\\cdot ${h}=${P}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, "P")} />;
}

export default { generateTask, renderTask, renderInput, checkAnswer, renderAnswer, renderExplanation, renderUserAnswer };
